<div
  class="py-2"
  *tuiLet="(cargoLoadingService.readonly$ | async)! as readonly"
>
  <div class="flex gap-x-2 items-center mb-4">
    <h2 class="font-semibold text-[16px]">Заказы</h2>
    <button
      [disabled]="readonly"
      size="s"
      tuiButton
      appearance="flat"
      (click)="sortByLoadingAddresses$.next()"
    >
      Сортировать в порядке загрузки
    </button>
    <app-active-processes class="mr-0 ml-auto"></app-active-processes>
  </div>

  <tui-accordion [rounded]="false">
    @for (
      order of preparedOrders$ | async;
      track order.original.id;
      let index = $index
    ) {
      <tui-accordion-item borders="top-bottom" [showArrow]="false">
        <div class="flex gap-x-2 py-1.5 pr-1.5">
          <div class="w-[40px] rounded-xl bg-purple-200 text-center">
            {{ index + 1 }}
          </div>
          <div class="w-[250px] overflow-hidden disappearing">
            {{ order.original.clientJson.name }}
          </div>

          <div class="w-[250px] overflow-hidden disappearing">
            {{ order.original.buyerCode }}
          </div>
          <div class="w-[250px] overflow-hidden disappearing flex items-center">
            {{ order.original.farmJson.name }}
            @if (order.original.farmJson.taxNonPayer) {
              <tui-svg
                tuiHint="Неплательщик НДС"
                class="text-red-500"
                src="tuiIconDollarSign"
              ></tui-svg>
            }
          </div>
          <div class="w-[100px] overflow-hidden disappearing">
            {{ order.computed.flowerTypeName }}
          </div>
          <div class="w-[50px] overflow-hidden disappearing">
            @if (order.original.cold) {
              <tui-svg [src]="snowflakeUrl"></tui-svg>
            }
          </div>
          <div class="w-[150px] overflow-hidden disappearing">
            {{ order.computed.packages }} BX
          </div>
          <div class="w-[150px] overflow-hidden disappearing">
            {{ order.computed.places }}
          </div>
          <div class="w-80px flex gap-x-2">
            <button
              [disabled]="readonly"
              (click)="$event.stopPropagation(); delete$.next(index)"
              size="s"
              appearance="icon"
              tuiIconButton
              icon="tuiIconTrash"
            ></button>
            <tui-badged-content>
              @if (order.original.attachmentId) {
                <tui-badge-notification size="s" tuiSlot="top">
                  1
                </tui-badge-notification>
              }
              <button
                (click)="
                  $event.stopPropagation();
                  openAttachmentsDialog$.next({
                    order: order.original,
                    index
                  })
                "
                tuiIconButton
                size="s"
                icon="tuiIconPaperclip"
              ></button>
            </tui-badged-content>
          </div>
        </div>

        <ng-template tuiAccordionItemContent>
          <app-order [order]="order.original"></app-order>
        </ng-template>
      </tui-accordion-item>
    }
  </tui-accordion>

  <div class="my-4 flex justify-between">
    <button
      [disabled]="readonly"
      size="s"
      icon="tuiIconPlus"
      tuiButton
      (click)="create$.next()"
    >
      Добавить предзаказ
    </button>
    <button
      tuiButton
      icon="tuiIconDownload"
      appearance="accent"
      size="s"
      (click)="downloadAllInvoices$.next()"
    >
      Скачать все инвойсы
    </button>
  </div>
</div>
